<template>
  <div v-if="errorMessages.length > 0" class="v-text-field__details mt-4">
    <div class="v-messages theme--light error--text" role="alert">
      <div class="v-messages__wrapper">
        <div
          v-for="(message, index) in errorMessages"
          :key="`error-message-${index}`"
          class="v-messages__message"
        >
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    errorMessages: {
      type: Array
    }
  }
};
</script>
